import React, { PureComponent, Fragment } from 'react';
// import Xiangyou from './../../public/images/xiangyou.png'
import moment from 'moment';
import servers from '@/api/server'
import {
    message,
    Table,
    Row, Col, Icon
} from 'antd';
import {
    CaretRightOutlined,
} from '@ant-design/icons';
import FilterForm from './form/filterForm.js';
import './../views/expenseApprove/upload.css'

const yearFormat = 'YYYY';
const dateFormat = 'YYYY-MM-DD'
const dateTimeFormat = 'YYYY-MM-DD HH:mm:ss'

class FilterTable extends PureComponent {
    static defaultProps = {
        pagination: {
            pageSize: 8,
            hideOnSinglePage: true,
            showQuickJumper: true,
        }
    }

    state = {
        data: [],
    };
    componentDidMount() {
        console.log(this.props.loading)
    }
    constructor() {
        super();
        this.setValue = this.setValue.bind(this)
    }

    setValue(feild, value) {
        this.setState({
            [feild]: value
        })
    }
    // customExpandIcon = (props) => {//改变了表格默认的展开
    //     if (props.record.children && props.record.children.length > 0) {
    //         if (props.expanded) {
    //             return <a style={{ color: 'black', verticalAlign: 'super', display: 'block-inlicj' }} onClick={e => {
    //                 props.onExpand(props.record, e);
    //             }}><i className="iconfont icon-jiantou f10 c_gray"></i></a>
    //         } else {
    //             return <a style={{ color: 'black', verticalAlign: 'super' }} onClick={e => {
    //                 props.onExpand(props.record, e);
    //             }}><i><img src='../images/xiangyou.png' alt='' style={{ width: '18px', height: '16px', verticalAlign: 'middle' }} /></i></a>
    //         }
    //     } else {
    //         return <span></span>
    //     }
    // }
    customExpandIcon = (props) => {
        if (props.record.children && props.record.children.length > 0) {
            if (props.expanded) {
                return <span className='tospanList' onClick={e => {
                    props.onExpand(props.record, e);
                }}> <Icon type="caret-down" /></span>
            } else {
                return <span className='tospanList' onClick={e => {
                    props.onExpand(props.record, e);
                }}><Icon type="caret-right" /></span>
            }
        } else {
            return <span className='tospanList' style={{ marginRight: 8 }}></span>
        }
    }
    onClickRow = (record) => {
        // console.log(record)
        return {
            onClick: () => {
                this.setState({
                    rowId: record.id,
                });
            },
        };
    }
    setRowClassName = (record) => {
        return record.id === this.state.rowId ? 'bgborder' : '';
    }
    render() {
        const {
            type,
            data,
            loading,
            columns,
            filterForm,
            dataFilter,
            rowKey,
            total,
            current,
            simple,
            pagination,
            rowType,
            refresh,
            styles,
            pageSize,
            scroll,
            size,
            className,
            ...rest
        } = this.props;
        console.log(this.props.pagination)
        const _dom = () => {
            if (refresh) {
                if (!loading) {
                    return (
                        <Table
                            className={className ? className : 'Table'}
                            loading={loading}
                            dataSource={data}
                            columns={columns}
                            pagination={pagination && {
                                ...pagination,
                                pageSize: 8,
                                total,
                                current,
                                // showTotal: total => {
                                //     return (
                                //         < span className='f12' > 总共 <span className='c_8bff'>{total}</span> 条数据,每页显示8条</span >
                                //     )
                                // },
                                // current
                            }}
                            locale={{
                                emptyText:
                                    <div style={{ marginTop: '32px' }}>
                                        <img src={servers.defaultNoEmptyPath} style={{ width: '58px' }} alt="暂无内容" />
                                        <div className='Empty'>暂无数据</div>
                                    </div>
                            }}
                            onChange={pagination => this.props.dataFilter(pagination)}
                            rowKey={rowKey ? rowKey : 'id'}
                            {...rest}
                            scroll={scroll ? scroll : ''}
                            // style={{ marginTop: '20px' }}

                            rowClassName={record => (record.children ? 'color1' : 'color2')}
                            expandIcon={(props) => this.customExpandIcon(props)}
                        // rowClassName={record => (record.distributePer === 1 ? styles.ye :  styles.gan)}
                        />
                    )
                }
            } else {
                return (
                    <Table
                        // defaultExpandAllRows={defaultExpandAllRows}
                        className={className ? className : 'Table'}
                        loading={loading}
                        dataSource={data}
                        columns={columns}
                        onHeaderRow={() => {
                            return {
                                onClick: () => {
                                    console.log(222)
                                }, // 点击表头行
                            };
                        }
                        }
                        pagination={{
                            ...pagination,
                            pageSize: pageSize || 8,
                            total,
                            simple,
                            size: size && 'small',
                            current,
                            showTotal: (total, Range) => {
                                console.log(total)
                                return (
                                    < span className='f12'> 总共 <span className='c_8bff'>{total}</span> 条数据,每页显示{pageSize || 8}条</span >
                                )
                            },
                            // current
                        }}
                        locale={{
                            emptyText:
                                <p style={{ marginTop: '32px' }}>
                                    <img src={servers.defaultNoEmptyPath} style={{ width: '58px' }} alt="暂无内容" />
                                    <div className='Empty'>暂无数据</div>
                                </p>
                        }}
                        // size={this.props.size}
                        onChange={pagination => { console.log(pagination); this.props.dataFilter(pagination) }}
                        rowKey={rowKey ? rowKey : 'id'}
                        {...rest}
                        style={{ marginTop: '8px' }}
                        rowClassName={(record, index) => {
                            let className = '';
                            if ((index % 2) == 0) {
                                className = 'bg_fff'
                            } else {
                                className = 'bg_f7'
                            }
                            if (record.id == this.props.allId) {
                                className = 'bg_8cc'
                            }
                            return className
                        }}
                        // rowClassName={(record, index) => (index % 2) == 0 ? 'color4' : 'color3'}
                        onRow={this.onClickRow}
                    // rowClassName={this.setRowClassName}
                    />
                )
            }
        }
        return (
            <div>
                {filterForm && <FilterForm formItems={filterForm} dataFilter={dataFilter} />}
                {rowType ?
                    <Row gutter={24}>
                        <Col span={rowType}>
                            {this.props.children}
                        </Col>
                        <Col span={24 - rowType}>
                            {_dom()}
                        </Col>
                    </Row>
                    :
                    _dom()
                }
            </div>
        );
    }
}

export default FilterTable;
